<app-breadcrumb [title]="title"></app-breadcrumb>

<div class="container-fluid my-5">
  <div class="row">
    <div class="col">
      <app-loader [show]="skeleton"></app-loader>
      <div [class.d-none]="skeleton">
        <form [formGroup]="profileForm" (ngSubmit)="save()">
          <input type="hidden" formControlName="userId">
          <input type="hidden" formControlName="isActive">

          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="border-bottom mb-3">
                  <div class="font-weight-normal">
                    <h6 class="fw-bold">Basic Inforation</h6>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="title">Title</label>
                  <select MyInput formControlName="title" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of titles" value="{{ item }}">{{ item }}
                    </option>
                  </select>
                  <my-error controlName="title" errorKey="required">Title is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="firstName">First Name</label>
                  <input MyInput formControlName="firstName" class="form-control form-control-sm" />
                  <my-error controlName="firstName" errorKey="required">First Name is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="middleName">Middle Name</label>
                  <input MyInput formControlName="middleName" class="form-control form-control-sm" />
                  <my-error controlName="middleName" errorKey="required">Middle Name is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="lastName">Last Name</label>
                  <input MyInput formControlName="lastName" class="form-control form-control-sm" />
                  <my-error controlName="lastName" errorKey="required">Last Name is required.</my-error>
                </div>
              </div>
            </div>
          </div>

          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="border-bottom mb-3">
                  <div class="font-weight-normal">
                    <h6 class="fw-bold">Home State and District (As per service record)</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="homeStateId">Home State</label>
                  <select MyInput formControlName="homeStateId" class="form-select form-select-sm"
                    (change)="getHomeDistricts($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of states" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="homeStateId" errorKey="required">Home State is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="homeDistrictId">Home District</label>
                  <select MyInput formControlName="homeDistrictId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of homeDistricts" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="homeDistrictId" errorKey="required">Home District is required.
                  </my-error>
                </div>
              </div>
            </div>
          </div>

          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="border-bottom mb-3">
                  <div class="font-weight-normal">
                    <h6 class="fw-bold">Other Details</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="aadharCardNo">Aadhar Card No.</label>
                  <input MyInput formControlName="aadharCardNo" class="form-control form-control-sm" />
                  <my-error controlName="aadharCardNo" errorKey="required">Aadhar Card No. is required.</my-error>
                  <my-error controlName="aadharCardNo" errorKey="pattern">Aadhar Card No. format is not valid.
                  </my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="genderId">Gender</label>
                  <select MyInput formControlName="genderId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of genders" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="genderId" errorKey="required">Gender is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="religionId">Religion</label>
                  <select MyInput formControlName="religionId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of religions" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="religionId" errorKey="required">Religion is required.</my-error>
                </div>
              </div>
              <div class="col-md-3" [class.d-none]="profileForm.get('religionId').value != 99">
                <div class="form-group mb-3">
                  <label class="form-label" for="otherReligion">Other Religion</label>
                  <input MyInput formControlName="otherReligion" class="form-control form-control-sm" />
                  <my-error controlName="otherReligion" errorKey="required">Other Religion is required.</my-error>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="npS_No">NPS No</label>
                  <input MyInput formControlName="npS_No" class="form-control form-control-sm" />
                  <my-error controlName="npS_No" errorKey="required">NPS No is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="cpF_No">CPF No.</label>
                  <input MyInput formControlName="cpF_No" class="form-control form-control-sm" />
                  <my-error controlName="cpF_No" errorKey="required">CPF No. is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="nvsJoiningDate">NVS Joining Date</label>
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                      </span>
                    </div>
                    <input MyInput formControlName="nvsJoiningDate" class="form-control form-control-sm"
                      [minDate]="{year: year - 60, month: 1, day: 1}" [maxDate]="{year: year, month: 12, day: 31}"
                      ngbDatepicker #nvsJoiningDate="ngbDatepicker" (click)="nvsJoiningDate.toggle()" />
                  </div>
                  <my-error controlName="nvsJoiningDate" errorKey="required">NVS Joining Date is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="birthDate">Birth Date</label>
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                      </span>
                    </div>
                    <input MyInput formControlName="birthDate" class="form-control form-control-sm" ngbDatepicker
                      [minDate]="{year: year - 60, month: 1, day: 1}" [maxDate]="{year: year - 20, month: 12, day: 31}"
                      #birthDate="ngbDatepicker" (click)="birthDate.toggle()" (change)="changeBirthDate()"
                      (dateSelect)="changeBirthDate()" />
                  </div>
                  <my-error controlName="birthDate" errorKey="required">Birth Date is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="retirementDate">Retirement Date</label>
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                      </span>
                    </div>
                    <input MyInput formControlName="retirementDate" class="form-control form-control-sm"
                      [minDate]="{year: year, month: 1, day: 1}" [maxDate]="{year: year + 60, month: 12, day: 31}"
                      ngbDatepicker #retirementDate="ngbDatepicker" (click)="retirementDate.toggle()" />
                  </div>
                  <my-error controlName="retirementDate" errorKey="required">Retirement Date is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="categoryId">Social Category</label>
                  <select MyInput formControlName="categoryId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of categories" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="categoryId" errorKey="required">Social Category is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="recruitmentCategoryId">Recruitment Category</label>
                  <select MyInput formControlName="recruitmentCategoryId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of recruitmentCategories" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="recruitmentCategoryId" errorKey="required">Recruitment Category is required.
                  </my-error>
                </div>
              </div>
              <!-- <label class="col-sm-6 col-form-label" for="isRetirementNear">Near Retirement ?</label>
              <div class="col-sm-6">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" formControlName="isRetirementNear"
                    name="isRetirementNear" id="isRetirementNear" [value]="true">
                  <label class="form-check-label" for="isRetirementNear">YES</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" formControlName="isRetirementNear"
                    name="isRetirementNear" id="isRetirementNear" [value]="false">
                  <label class="form-check-label" for="isRetirementNear">NO</label>
                </div>
                <my-error controlName="isRetirementNear" errorKey="required">Near Retirement? is
                  required.
                </my-error>
              </div> -->
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isSpecReqDrive" class="form-check-input"
                    id="isSpecReqDrive">
                  <label class="form-label" for="isSpecReqDrive">Spec. Rectt. Drive (10 year bond)</label>
                </div>
                <my-error controlName="isSpecReqDrive" errorKey="required">Spec. Rectt. Drive is required.</my-error>
              </div>
            </div>

            <div class="row" [class.d-none]="!profileForm.get('isSpecReqDrive').value">
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="specReqDriveYear">Spec. Rectt. Drive Year</label>
                  <select MyInput formControlName="specReqDriveYear" class="form-select form-select-sm">
                    <option selected>--SELECT--</option>
                    <option value="2006">2006</option>
                    <option value="2010">2010</option>
                    <option value="2022">2022</option>
                  </select>
                  <my-error controlName="specReqDriveYear" errorKey="required">Spec. Rectt. Drive Year is required.
                  </my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="appointRegionId">Appointed Region</label>
                  <select MyInput formControlName="appointRegionId" class="form-select form-select-sm">
                    <option selected>--SELECT--</option>
                    <option *ngFor="let item of regions" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="appointRegionId" errorKey="required">Appointed Region is required.</my-error>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-3">
                  <label class="form-label" for="specJoiningDate">Date of joining (Spec. Rectt. Drive)</label>
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                      </span>
                    </div>
                    <input MyInput formControlName="specJoiningDate" class="form-control form-control-sm"
                      [minDate]="{year: 2006}" [maxDate]="{year: 2030}" ngbDatepicker #specJoiningDate="ngbDatepicker"
                      (click)="specJoiningDate.toggle()" />
                  </div>
                  <my-error controlName="specJoiningDate" errorKey="required">Date of joining is required.</my-error>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!profileForm.valid || loading"
              type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <a (click)="goBack()" class="btn btn-outline-primary">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
